import { Link, usePage } from '@inertiajs/react'
import type { PropsWithChildren } from 'react'

import { Flash } from '@/components/Flash'
import { Footer } from '@/components/Footer'
import { ThemeToggle } from '@/components/ThemeToggle'
import { LoggedUserNavbar } from '@/components/navbar/LoggedUserNavbar'
import { UnloggedNavbar } from '@/components/navbar/UnloggedNavbar'
import { newUserSessionPath, rootPath } from '@/lib/routes'
import type { PageProps } from '@/types/inertia'

export function AppLayout({ children }: PropsWithChildren) {
  const page = usePage<PageProps>()
  const { auth } = page.props

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="fixed inset-x-0 top-0 z-30 border-b border-border bg-background/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-6xl items-center gap-4 px-4">
          <Link
            className="flex items-center gap-3"
            href={auth.signed_in ? rootPath() : newUserSessionPath()}
          >
            <span className="text-xl font-semibold tracking-tight">Platanus Track</span>
          </Link>
          <div className="ml-auto flex items-center gap-2">
            <ThemeToggle />
            <div className="hidden items-center gap-2 lg:flex">
              {!auth.signed_in && <UnloggedNavbar />}
              {auth.user && <LoggedUserNavbar />}
            </div>
          </div>
        </div>
      </header>

      <Flash />

      <main className="pt-16">{children}</main>

      <Footer />
    </div>
  )
}
